import { render } from "./LibraryWrapperElement.vue?vue&type=template&id=4aba8a21&scoped=true"
import script from "./LibraryWrapperElement.vue?vue&type=script&lang=js"
export * from "./LibraryWrapperElement.vue?vue&type=script&lang=js"

import "./LibraryWrapperElement.vue?vue&type=style&index=0&id=4aba8a21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aba8a21"]])

export default __exports__